import { render, staticRenderFns } from "./MyUeditor.vue?vue&type=template&id=fa0003c0&scoped=true"
import script from "./MyUeditor.vue?vue&type=script&lang=js"
export * from "./MyUeditor.vue?vue&type=script&lang=js"
import style0 from "./MyUeditor.vue?vue&type=style&index=0&id=fa0003c0&prod&scoped=true&lang=css"
import style1 from "./MyUeditor.vue?vue&type=style&index=1&id=fa0003c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0003c0",
  null
  
)

export default component.exports